import { FocusOnDirective } from './focus-on.directive';

export const FOCUS_ON_DECLARATIONS = [FocusOnDirective];

export * from './focus-on.directive';
